import { useEffect, useRef, useState } from 'react';

export const useWindowScrollReachedEnd = (threshold = 0) => {
  const lastScrollRef = useRef(0);
  const [reachedEnd, setReachedEnd] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > lastScrollRef.current) {
        setReachedEnd(window.innerHeight + (window.scrollY + threshold) >= document.body.scrollHeight - 100);
      } else {
        setReachedEnd(false);
      }

      lastScrollRef.current = scrollTop <= 0 ? 0 : scrollTop;
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return reachedEnd;
};
